import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  list: {
    alignItems: 'stretch',
    gap: theme.spacing(2),
    flexFlow: 'row nowrap',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${theme.spacing(37.5)}), 1fr))`,
    marginBottom: theme.spacing(2),
  },

  emptyPlaceholder: {
    display: 'flex',
    height: '100%',
  },
}));
